import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Integrations from "../../../integration/Integrations.jsx";
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import GlobalHelper from "../../../common/GlobalHelper";
import { BILLING_TYPE } from '../../../state/invoice/InvoiceBillingType';

class InvoiceExportedToLightspeedEcomEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            invoice: this.props.invoice || null,
            proposal: this.props.proposal || null,
            modal: '',
            parentInvoiceExternalLink: '',
        }
    }

    componentDidMount() {
        this.fetchParentInvoice()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            invoice: nextProps.invoice || null,
            proposal: nextProps.proposal || null,
        })
    }

    fetchParentInvoice() {
        const parentInvoiceId = this.state.invoice.attributes.returnOfInvoiceId
        if (parentInvoiceId) {
            AppContext.getApiClient().get("/invoices/" + parentInvoiceId).then(res => {
                const link = GlobalHelper.getObjectExternalLink(res, "ls-ecom")

                if (link) {
                    this.setState({
                        parentInvoiceExternalLink: link
                    })
                }
            })
        }
    }

    renderMessage() {
        switch (this.state.object.attributes.entityType) {
            case 'main':
                return !this.isReturn() ?
                    <FormattedMessage
                        id="invoice.analytics.events.exported.ls_ecom.text"
                        defaultMessage="Invoice {identifier} has been exported to Lightspeed eCom as a completed order"
                        values={{
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                        }}
                    /> : <FormattedMessage
                        id="invoice.analytics.events.return_exported.ls_ecom.text"
                        defaultMessage="Return {identifier} has been exported to Lightspeed eCom as a completed order"
                        values={{
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                        }}
                    />
            case 'void':
                return <FormattedMessage
                    id="invoice.analytics.events.exported.ls_ecom.void_text"
                    defaultMessage="Invoice {identifier} has been refunded in Lightspeed eCom"
                    values={{
                        identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                    }}
                />
            case 'invoice-adjustment':
            case 'payment-adjustment':
                return <span>
                    <FormattedMessage
                        id="invoice.analytics.events.exported.ls_ecom.adjustment_text"
                        defaultMessage="An adjustment for {identifier} has been made in Lightspeed eCom"
                        values={{
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                        }}
                    />
                    {
                        this.state.object.attributes.metadata && this.state.object.attributes.metadata.notes ?
                            <span className={'ml-1'}>
                                <span className={'mr-1'}>/</span>
                                <FormattedMessage
                                    id="invoice.analytics.events.exported.ls_ecom.invoice_adjustment_notes"
                                    defaultMessage="Reason: {notes}"
                                    values={{
                                        notes: this.state.object.attributes.metadata.notes,
                                    }}
                                />
                            </span> : ''
                    }
                </span>
        }
        return ''
    }

    isReturn() {
        return this.state.invoice && this.state.invoice.attributes.billingType === BILLING_TYPE.RETURN
    }

    isVoided() {
        return this.state.invoice && this.state.invoice.attributes.status === "voided"
    }

    render() {
        let lightspeedEcomUrl = this.isReturn() ?
            Integrations.getPaymentTransactionExternalUrl(this.state.parentInvoiceExternalLink) : this.isVoided() ?
                Integrations.getPaymentTransactionExternalUrl(GlobalHelper.getObjectExternalLink(this.state.invoice, 'ls-ecom')) :
                Integrations.getPaymentTransactionExternalUrl(this.state.object)

        return <div className={"row " + this.state.className}>
            <div className={'col-12'}>
                <p className={'mb-2'}>
                    {this.renderMessage()}
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-3'}>
                    <a href={lightspeedEcomUrl} target="_blank">
                        <img src="/images/lightspeed_ecom_logo.png" width="150px" />
                    </a>
                </div>
                <div >
                    <p className={'mb-0'}>
                        <a href={lightspeedEcomUrl} target={'_blank'} className={'btn btn-sm btn-outline-primary'}>
                            <FormattedMessage
                                id="invoice.analytics.events.exported.ls_ecom.open"
                                defaultMessage="Open sale in Lightspeed eCom"
                            />
                        </a>
                    </p>
                </div>
            </div>
        </div>
    }

}

export default InvoiceExportedToLightspeedEcomEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-ls-ecom.component.jsx